import React from 'react';
import { LanguageCode, WebsiteLanguage } from '../../Models/Models';

/**
 * Status of a translation's language on the current website: removed from the site (still
 * editable, but not synced) or CMS-only (kept out of the public site).
 */
const TranslationLanguageBadges: React.FC<{ code: LanguageCode; siteLanguages: WebsiteLanguage[] | null }> = ({ code, siteLanguages }) => {
    if (!siteLanguages) return null;

    const siteLanguage = siteLanguages.find(l => l.languageCode === code);

    if (!siteLanguage) {
        return (
            <span
                className="st-trans-card__badge st-trans-card__badge--warn"
                title="Jazyk bol odobratý zo stránky. Preklad môžete naďalej upravovať, ale nezverejní sa."
            >
                Jazyk nie je povolený
            </span>
        );
    }

    if (!siteLanguage.isPublic) {
        return (
            <span className="st-trans-card__badge st-trans-card__badge--muted" title="Tento jazyk sa nesynchronizuje na verejnú stránku.">
                Len v CMS
            </span>
        );
    }

    return null;
};

export default TranslationLanguageBadges;
